import axios from "axios";
import userManager from "../Oidc/userManager";

const UNAUTHORIZED = 401;

let renewPromise = null;
let isRedirecting = false;

const renewToken = () => {
  if (!renewPromise) {
    renewPromise = userManager.signinSilent().finally(() => {
      renewPromise = null;
    });
  }
  return renewPromise;
};

const redirectToLogin = () => {
  if (isRedirecting) {
    return;
  }
  isRedirecting = true;
  userManager.signinRedirect().catch(() => {
    isRedirecting = false;
  });
};

export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const status = error.response?.status;

      if (status !== UNAUTHORIZED || !originalRequest || originalRequest._retry) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        const user = await renewToken();
        const token = user?.access_token;
        if (!token) {
          throw new Error("Silent renew returned no access token");
        }
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return axios(originalRequest);
      } catch (renewError) {
        redirectToLogin();
        return Promise.reject(error);
      }
    }
  );
};

export default setupAxiosInterceptors;
